import { render } from "./dinamicDialog.vue?vue&type=template&id=9d5e9728&scoped=true"
import script from "./dinamicDialog.vue?vue&type=script&lang=js"
export * from "./dinamicDialog.vue?vue&type=script&lang=js"

import "./dinamicDialog.vue?vue&type=style&index=0&id=9d5e9728&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d5e9728"]])

export default __exports__